import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["feedbackUrl"];
import { MainMenuProvider } from "../MainMenu/context";
import DashboardMenu from "./DashboardMenu";
import { jsx as _jsx } from "react/jsx-runtime";
var DashboardMenuWithContext = function DashboardMenuWithContext(_ref) {
  var feedbackUrl = _ref.feedbackUrl,
    mainMenuProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(MainMenuProvider, _objectSpread(_objectSpread({
    variant: "dashboard"
  }, mainMenuProps), {}, {
    children: /*#__PURE__*/_jsx(DashboardMenu, {
      feedbackUrl: feedbackUrl
    })
  }));
};
export default DashboardMenuWithContext;